



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsCatalogCardComponentsLink extends Vue {
  // Props
  @Prop({ type: String, default: '' })
  phone: string;

  @Prop({ type: String, default: '' })
  mail: string;

  @Prop({ type: String, default: '' })
  site: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/sidebar/components/LinkElement.vue